import {
  BASE_URL,
  CREATE_ROLE,
  ROLE,
  DELETE_ROLE,
  MENU,
  UPDATE_ROLE,
} from "../config";
import { getSessionId } from "../utils/SessionHandler";
import { handleResponse } from "./responseHandler";

export async function createRole(roleData) {
  const response = await fetch(BASE_URL + CREATE_ROLE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
    body: JSON.stringify(roleData),
  });
  return handleResponse(response);
}

export async function updateRole(roleData, id) {
  const response = await fetch(`${BASE_URL}${UPDATE_ROLE}/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
    body: JSON.stringify(roleData),
  });
  return handleResponse(response);
}

export async function fetchRoles() {
  const response = await fetch(BASE_URL + ROLE, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });
  return handleResponse(response);
}

export async function fetchMenus() {
  const response = await fetch(BASE_URL + MENU, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });
  return handleResponse(response);
}

export async function deleteRole(id) {
  const response = await fetch(`${BASE_URL}${DELETE_ROLE}/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
  });
  return handleResponse(response);
}
